// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalculationCard__container___WpTOA {
    padding: 1.2rem 1.1rem 1.6rem;
    background-color: var(--color-bg-stripe);
    border-radius: 0.4rem;
}

.CalculationCard__header___d0IxG {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
}

.CalculationCard__rename___o9vCg {
    margin-top: 0.8rem;
}

.CalculationCard__body___H8cGd > div {
    padding: 0.8rem 0;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.CalculationCard__rename___o9vCg .TextField {
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/MachineLearningModal/RightMenu/Calculations/CalculationCard/CalculationCard.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,uEAAuE;AACvE;IACI,YAAY;AAChB","sourcesContent":[".container {\n    padding: 1.2rem 1.1rem 1.6rem;\n    background-color: var(--color-bg-stripe);\n    border-radius: 0.4rem;\n}\n\n.header {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.rename {\n    margin-top: 0.8rem;\n}\n\n.body > div {\n    padding: 0.8rem 0;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.rename :global(.TextField) {\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CalculationCard__container___WpTOA`,
	"header": `CalculationCard__header___d0IxG`,
	"rename": `CalculationCard__rename___o9vCg`,
	"body": `CalculationCard__body___H8cGd`
};
export default ___CSS_LOADER_EXPORT___;
